import { render, staticRenderFns } from "./FormPart4.vue?vue&type=template&id=2ba65350&scoped=true"
import script from "./FormPart4.vue?vue&type=script&lang=js"
export * from "./FormPart4.vue?vue&type=script&lang=js"
import style0 from "./FormPart4.vue?vue&type=style&index=0&id=2ba65350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba65350",
  null
  
)

export default component.exports